import {getOptions} from '../options'

export default async function setSession(session, resetStore = true) {
  const {apolloClient, saveSession, wsClient} = getOptions()

  if (resetStore) {
    await apolloClient.clearStore()
  }

  await saveSession(session)

  if (resetStore) {
    await apolloClient.reFetchObservableQueries()
  }

  if (wsClient) {
    // @ts-expect-error tryReconnect is not in the types
    wsClient.tryReconnect()
  }
}
